import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { IJobAnalysis } from "../database/schema";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const fetcher = (url: string) => fetch(url).then(res => res.json());

export const isNewAnalysis = (analysis:IJobAnalysis) => {
  if(!analysis || !analysis.created_at) {
    return false;
  }
  const createdAt = new Date(analysis.created_at).getTime();
  const now = Date.now();
  const diffMs = now - createdAt;
  // Considered new if created within the last 24 hours
  const oneDayMs = 24 * 60 * 60 * 1000;
  return diffMs < oneDayMs;
}